import {PlaceParticipationValueObject} from "../../../vo/content/place/PlaceParticipationValueObject";
import {DataTransferObjectValidation} from "../../../../type/Types";

export namespace PlaceParticipationDataTransferObject {
    export type Post = {
        placePathJointId: bigint
        userId: bigint
        mediaId: string
        mediaCode: string
        answer: string | null
        campaignCode: string | null
        placeAttractionId: bigint | null
    }

    export namespace Post {
        export const description: Record<keyof Post, string> = {
            ...PlaceParticipationValueObject.description,
            campaignCode: '캠페인 코드',
            placeAttractionId: '플레이스 명소 ID'
        }

        export const validation: DataTransferObjectValidation<Post> = {
            placePathJointId(o: string): bigint | Error {
                return DataTransferObjectValidation.transformBigInt(o, 'placePathJointId')
            },
            userId(o: string): bigint | Error {
                return DataTransferObjectValidation.transformBigInt(o, 'userId')
            },
            mediaId(o: string): string | Error {
                return o
            },
            mediaCode(o: string): string | Error {
                return o
            },
            answer(o: string): string | null | Error {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'answer')
            },
            campaignCode(o: string): string | null | Error {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'campaignCode')
            },
            placeAttractionId(o: string): bigint | Error {
                return DataTransferObjectValidation.transformBigInt(o, 'placeAttractionId')
            }
        }
    }
}